export default __webpack_public_path__ + "static/media/professional_photo2.216ffeda.png";